import Vue from 'vue'
import Router from 'vue-router'
import getopenid from '@/project/ceshi/getopenid.vue'// 在线中心主页
/* 在线咨询 */
import onlineIndex from '@/project/onlineServicesProject/onlineIndex.vue'// 在线中心主页
import patientChatWindow from '@/project/onlineServicesProject/patient/patientChatWindow.vue'// 患者聊天窗口
import onlineDoctorList from '@/project/onlineServicesProject/onlineDoctorList.vue'// 医生列表
import patientList from '@/project/onlineServicesProject/doctor/patientList.vue'// 患者列表  医生
/* 服务评价 */
import ServiceValuation from '@/project/ValuationProject/serviceValuation.vue'// 服务评价页面
import serviceSubmissionResult from '@/project/ValuationProject/serviceSubmissionResult.vue' // 服务评价详情页面
import surveyServiceValuation from '@/project/ValuationProject/surveyServiceValuation.vue' // 吐槽平台 处理评价调查问卷
import SystemSurvey from '@/project/ValuationProject/SystemSurvey.vue' // 吐槽平台系统设计
import SystemSurveyIndex from '@/project/ValuationProject/SystemSurveyIndex.vue' // 吐槽平台 入口
import dailyEvaluation from '@/project/ValuationProject/dailyEvaluation.vue'// 服务评价页面
/* 积分 */
import IntegralRedPacket from '@/project/IntegralProject/IntegralRedPacket.vue' // 积分页面
/* 预约 */
import reservationIndex from '@/project/MyReservationProject/reservationIndex.vue' // 我的预约
import reservationtimestamp from '@/project/MyReservationProject/reservationtimestamp.vue' // 我的预约

import reservationTable from '@/project/MyReservationProject/reservationTable.vue' // 我的预约
import reservationGeneral from '@/project/MyReservationProject/reservationGeneral.vue' // 通用预约
import reservationInjection from '@/project/MyReservationProject/reservationInjection.vue' // 通用预约
import reservationDetails from '@/project/MyReservationProject/reservationDetails.vue' // 预约详情
import reservationDoctor from '@/project/MyReservationProject/reservationDoctor.vue' // 预约医生
import surgicalAppointment from '@/project/MyReservationProject/surgicalAppointment.vue' // 手术预约
import surgicalAppointmentAdd from '@/project/MyReservationProject/surgicalAppointmentAdd.vue' // 手术预约 新增

import reservationChineseMedical from '@/project/MyReservationProject/reservationChineseMedical.vue' // 中医预约 查询
/* 我的胚胎 */
import myEmbryo from '@/project/myEmbryoProject/myEmbryo.vue' // 我的胚胎
/* VIP */
import vipnotify from '@/project/vipnotifyProject/vipnotify.vue' // VIP告知书
import vipAppointment from '@/project/vipnotifyProject/vipAppointment.vue' // VIP预约
import vipAppointmentDetila from '@/project/vipnotifyProject/vipAppointmentDetila.vue' // VIP预约详情
/* 积分商城 */
import integralMall from '@/project/integralMallProject/integralMallCS.vue' // 积分商城
import integralMallDetail from '@/project/integralMallProject/integralMallDetail.vue' // 积分商城商品详情
import integralMallOrder from '@/project/integralMallProject/integralMallOrder.vue' // 积分商城确认订单
import integralMallOrderResult from '@/project/integralMallProject/integralMallOrderResult.vue' // 积分商城确认订单
import integraMallEmbryo from '@/project/integralMallProject/integraMallEmbryo.vue' // 积分商城胚胎续费
import integralMallList from '@/project/integralMallProject/integralMallList.vue' // 积分商城
import integralMallListOne from '@/project/integralMallProject/integralMallListOne.vue' // 积分商城  礼品卡
import integralMallExamine from '@/project/integralMallProject/integralMallExamine.vue' // 诊疗项目描述
import integralMallExchangeDetails from '@/project/integralMallProject/integralMallExchangeDetails.vue' // 诊疗项目描述
import pointsMessage from '@/project/integralMallProject/pointsMessage.vue' // 兑换详情


/* 用药助手 */
import medicineDetail from '@/project/medicineAssistant/medicineDetail.vue' // 用药助手
/* 自助建档 */
import filingNotice from '@/project/selfHelpFilingProject/filingNotice.vue' // 建档告知书
import filingInformation from '@/project/selfHelpFilingProject/filingInformation.vue' // 填写建档信息
import selfFillingMachine from '@/project/selfHelpFilingProject/selfFillingMachine.vue' // 填写建档信息

import nucleicAcid from '@/project/selfHelpFilingProject/nucleicAcid.vue' // 核酸检测开单
import nucleicAcidDetail from '@/project/selfHelpFilingProject/nucleicAcidDetail.vue' // 核酸检测开单 详情

import fsAuthorizationLetter from '@/project/selfHelpFilingProject/fsAuthorizationLetter.vue' // 复苏同意书签署

/*核酸检测开单*/
/* 文章 */
import wrapping from '@/project/articleProject/wrapping.vue' // 包皮
import qlxj from '@/project/articleProject/qlxj.vue' // 取卵移植宣教
import threeDiseases from '@/project/articleProject/threeDiseases.vue' // 取卵移植宣教
import xnts from '@/project/articleProject/xnti.vue' // 肺炎
import xnkt from '@/project/articleProject/xnkt.vue' // 西囡空调暂停使用空调
import xntk1 from '@/project/articleProject/xntk1.vue' // 听课
import xntk2 from '@/project/articleProject/xntk2.vue' // 听课
/* 锦江妇幼保健院生殖中心 订阅号 我要预约 */
import appointmentPresentation from '@/project/articleProject/appointmentPresentation.vue' // 我要预约
/* 投票 */
import doctorVote from '@/project/voteProject/doctorVote1.vue' // 医生投票
/* 微信扫一扫 */
import sweepSign from '@/project/sweepProject/sweepSign.vue' // 微信扫一扫签到
/* 微信  医院提醒详情 */
import newDetail from '@/project/newDetailProject/newDetail.vue' // 医院提醒详情
/* 试管百科 */
import TestTubeEncyclopediaIndex from '@/project/testTubeEncyclopedia/TestTubeEncyclopediaIndex.vue' //
import TestTubeEncyclopediaList from '@/project/testTubeEncyclopedia/TestTubeEncyclopediaList.vue' //
/* 随访调查 */
import OneInvestigation from '@/project/followUpInvestigationProject/OneInvestigation.vue' // 第一次随访调查
/* 区域服务 */
import regionalTeamList from '@/project/regionalServiceProject/regionalTeamList.vue' // 区域服务列表页
import regionalTeamDetail from '@/project/regionalServiceProject/regionalTeamDetail.vue' // 区域服务介绍页
/* 完善信息 */
import perfectMessageWoman from '@/project/perfectMessageProject/perfectMessageWoman.vue' // 完善个人信息 女 填写
import perfectMessageMan from '@/project/perfectMessageProject/perfectMessageMan.vue' // 完善个人信息 男 填写
/* 助孕登记 */
import pregnancyRegistration from '@/project/pregnancyProject/pregnancyRegistration.vue' // 助孕登记
import pregnancyPatientDetails from '@/project/pregnancyProject/pregnancyPatientDetails.vue' // 推荐患者明细
import pregnancyPatientNews from '@/project/pregnancyProject/pregnancyPatientNews.vue' // 短信模板
/* 活动 */
import nationalDay from '@/project/activitiesProject/nationalDay.vue' // 国庆活动
import healthReporting from '@/project/activitiesProject/healthReporting.vue' // 就诊人个人情况填报表
/* 院内停车 */
import stopCarIndex from '@/project/stopCarProject/stopCarIndex.vue' // 院内停车 首页
import hospitalA from '@/project/articleProject/hospitalAddress.vue' // 通讯录
/* 测试 */
import fenxiang from '@/project/ceshi/fenxiang.vue' // 分享
import noFind from '@/project/noFind.vue'// 404页面
import tabslideTamplete from '@/components/bbbbbb.vue'// 404页面
import ceshi from '@/components/ceshi.vue'// 404页面
import ditu from '@/components/ditu.vue'// 经纬度定位
/* 义幻在线问诊 */
import doctordetailTZ from '@/project/outsideProject/doctordetailTZ.vue' // 义幻 医生详情跳转
import tup from '@/project/ceshi/tup.vue'
/*互联网医院*/
import hospitallookindex from '@/project/internetHospital/lookIndex.vue'
import consultationRegistration from '@/project/internetHospital/consultationRegistration.vue'
/* 在线测评、问卷 */
import questionnaire from '@/project/exam/questionnaire.vue'  //在线问诊单题翻页
import startExam from '@/project/exam/startExam.vue'
import startCheck from '@/project/exam/startCheck.vue'
import startExamNoPerson from '@/project/exam/startExamNoPerson.vue'
/** 前置审方 */
import prescnoVerify from '@/project/prescnoVerifyProject/prescnoVerify.vue'    //处方审核
import patientlabinfo from '@/project/prescnoVerifyProject/patientlabinfo.vue'
/** 订餐服务 */
import orderFood from '@/project/orderFoodProject/orderFood.vue'

/** 优选crm注册 */
import yxcrmregister from '@/project/rkw/yxcrmregister.vue'

/** mdt */
import mdt from '@/project/mdt/mdtSpeacInfo.vue'
import mdtregister from '@/project/mdt/mdtregister.vue'


/** vip */
import vipHcg from '@/project/vipMsg/vipHcgMsg.vue'
import vipFet from '@/project/vipMsg/vipFetMsg.vue'

Vue.use(Router)
const router = [
  {
    path: '/tup',
    name: '32423',
    component: tup
  },
  {
    path: '/tabslideTamplete',
    name: 'miban',
    component: tabslideTamplete
  },
  {
    path: '/getopenid',
    name: '获取openid',
    component: getopenid
  },
  {
    path: '/ditu',
    name: '经纬坐标',
    component: ditu
  },
  {
    path: '/fenxiang',
    name: '分享',
    component: fenxiang
  },
  {
    path: '/nationalDay',
    name: '助孕登记报名表',
    component: nationalDay
  },
  {
    path: '/healthReporting',
    name: '就诊人个人健康情况填报表',
    component: healthReporting
  },
  {
    path: '/ServiceValuation',
    name: '服务评价',
    component: ServiceValuation
  },
  {
    path: '/dailyEvaluation',
    name: '每日服务评价',
    component: dailyEvaluation
  },
  {
    path: '/serviceSubmissionResult',
    name: '评价详情',
    component: serviceSubmissionResult
  },
  {
    path: '/SystemSurvey',
    name: '吐槽平台系统设计',
    component: SystemSurvey
  },
  {
    path: '/SystemSurveyIndex',
    name: '吐槽平台 入口',
    component: SystemSurveyIndex
  },
  {
    path: '/surveyServiceValuation',
    name: '吐槽处理评价问卷',
    component: surveyServiceValuation
  },
  {
    path: '/IntegralRedPacket',
    name: '积分红包',
    component: IntegralRedPacket
  },
  {
    path: '/surgicalAppointment',
    name: '手术预约',
    component: surgicalAppointment
  },
  {
    path: '/surgicalAppointmentAdd',
    name: '手术预约新增',
    component: surgicalAppointmentAdd
  },
  {
    path: '/reservationTable',
    name: '我的预约',
    component: reservationTable
  },
  {
    path: '/reservationIndex',
    name: '我的预约时间戳',
    component: reservationIndex
  },
  {
    path:'/reservationtimestamp',
    name: '我的预约',
    component: reservationtimestamp
  },
  {
    path: '/reservationGeneral',
    name: '通用预约',
    component: reservationGeneral
  },
  {
    path: '/reservationChineseMedical',
    name: '中医预约',
    component: reservationChineseMedical
  },
  {
    path: '/reservationInjection',
    name: '注射预约',
    component: reservationInjection
  },
  {
    path: '/reservationDetails',
    name: '预约详情',
    component: reservationDetails
  },
  {
    path: '/reservationDoctor',
    name: '预约医生',
    component: reservationDoctor
  },
  {
    path: '/myEmbryo',
    name: '我的胚胎',
    component:resolve => require(['@/project/myEmbryoProject/myEmbryo'],resolve)
  },
   {
     path: '/activityPosterDisplayDetial',
     name: '活动海报转发',
     component: resolve => require(['@/project/pregnancyProject/activityPosterDisplayDetial'],resolve)
   },
   {
     path: '/activityPosterManage',
     name: '海报查询',
     component: resolve => require(['@/project/pregnancyProject/activityPosterManage'],resolve)
   },
  {
    path: '/activityPosterDisplay',
    name: '活动海报分享',
    component: resolve => require(['@/project/pregnancyProject/activityPosterDisplay'],resolve)
  },
  {
    path: '/vipnotify',
    name: '患者告知书',
    component: vipnotify
  },
  {
    path: '/vipAppointment',
    name: 'VIP预约活动',
    component: vipAppointment
  },
  {
    path: '/vipAppointmentDetila',
    name: 'VIP预约详情',
    component: vipAppointmentDetila
  },
  {
    path: '/integralMallList',
    name: '积分服务',
    component: integralMallList
  },
  {
    path: '/integralMallListOne',
    name: '积分礼品卡',
    component: integralMallListOne
  },
  {
    path: '/integralMallExamine',
    name: '诊疗项目',
    component: integralMallExamine
  },
  {
    path: '/integralMallExchangeDetails',
    name: '商城兑换记录',
    component: integralMallExchangeDetails
  },
  {
    path: '/integralMall',
    name: '积分商城',
    component: integralMall
  },
  {
    path: '/pointsMessage',
    name: '兑换详情',
    component: pointsMessage
  },
/*  {
    path: '/integralMall',
    name: '积分商城1',
    component: integralMall,
    redirect:'/integralMallIndex',
    children:[
      {
        path: '/integralMallIndex',
        name: '积分商城首页',
        component: integralMallIndex,
      },
      {
        path: '/integralMallMine',
        name: '积分商城我的',
        component: integralMallMine,
      },
      ]
  }, */
  {
    path: '/integralMallDetail',
    name: '积分商城商品详情',
    component: integralMallDetail
  },
  {
    path: '/integralMallOrder',
    name: '积分商城确认订单',
    component: integralMallOrder
  },
  {
    path: '/integralMallOrderResult',
    name: '积分商城订单支付结果',
    component: integralMallOrderResult
  },
  {
    path: '/integraMallEmbryo',
    name: '积分商城胚胎续费',
    component: integraMallEmbryo
  },
  {
    path: '/hospitallookindex',
    name: '互联网医院查看记录',
    component: hospitallookindex
  },
  {
    path: '/consultationRegistration',
    name: '咨询注册',
    component: consultationRegistration
  },
  {
    path: '/medicineDetail',
    name: '用药助手详情',
    component: medicineDetail
  },
  {
    path: '/wrapping',
    name: '包皮',
    component: wrapping
  },
  {
    path: '/qlxj',
    name: '取卵饮食宣教',
    component: qlxj
  },
  {
    path: '/threeDiseases',
    name: '三病宣传',
    component: threeDiseases
  },
  {
    path: '/xnts',
    name: '肺炎宣传',
    component: xnts
  },
  {
    path: '/xnkt',
    name: '西囡空调通知',
    component: xnkt
  },
  {
    path: '/xntk1',
    name: '听课',
    component: xntk1
  },
  {
    path: '/xntk2',
    name: '听课4',
    component: xntk2
  },

  {
    path: '/appointmentPresentation',
    name: '我要预约',
    component: appointmentPresentation
  },
  {
    path: '/doctorVote',
    name: '医生投票',
    component: doctorVote
  },
  {
    path: '/sweepSign',
    name: '扫一扫签到',
    component: sweepSign
  },
  {
    path: '/newDetail',
    name: '医院提醒详情',
    component: newDetail
  },
  {
    path: '/onlineIndex',
    name: '在线中心主页',
    component: onlineIndex
  },
  {
    path: '/patientChatWindow',
    name: '患者聊天窗口',
    component: patientChatWindow
  },
  {
    path: '/onlineDoctorList',
    name: '医生列表',
    component: onlineDoctorList
  },
  {
    path: '/patientList',
    name: '患者消息列表',
    component: patientList
  },
  {
    path: '/filingNotice',
    name: '建档告知书',
    component: filingNotice
  },
  {
    path: '/filingInformation',
    name: '填写建档信息',
    component: filingInformation
  },
  {
    path: '/selfFillingMachine',
    name: '自助开单',
    component: selfFillingMachine
  },
  {
    path: '/nucleicAcid',
    name: '核酸检测开单',
    component: nucleicAcid
  },
  {
    path: '/nucleicAcidDetail',
    name: '核酸检测开单详情',
    component: nucleicAcidDetail
  },
  {
    path: '/fsAuthorizationLetter',
    name: '复苏同意书签署',
    component: fsAuthorizationLetter
  },
  {
    path: '/TestTubeEncyclopediaIndex',
    name: '试管百科',
    component: TestTubeEncyclopediaIndex
  },
  {
    path: '/OneInvestigation',
    name: '第一次随访调查',
    component: OneInvestigation
  },
  {
    path: '/regionalTeamList',
    name: '区域服务列表页',
    component: regionalTeamList
  },
  {
    path: '/regionalTeamDetail',
    name: '区域服务详情页',
    component: regionalTeamDetail
  },
  {
    path: '/TestTubeEncyclopediaList',
    name: '试管百科文章列表',
    component: TestTubeEncyclopediaList
  },
  {
    path: '/perfectMessageWoman',
    name: '完善个人信息女',
    component: perfectMessageWoman
  },
  {
    path: '/perfectMessageMan',
    name: '完善个人信息男',
    component: perfectMessageMan
  },
  {
    path: '/pregnancyRegistration',
    name: '助孕登记',
    component: pregnancyRegistration
  },
  {
    path: '/pregnancyPatientNews',
    name: '短信模板',
    component: pregnancyPatientNews
  },
  {
    path: '/pregnancyPatientDetails',
    name: '推荐患者明细',
    component: pregnancyPatientDetails
  },
  {
    path: '/stopCarIndex',
    name: '院内停车首页',
    component: stopCarIndex
  },
  {
    path: '/hospitalA',
    name: '通讯录',
    component: hospitalA
  },
  {
    path: '/doctordetailTZ',
    name: '义幻医生详情跳转',
    component: doctordetailTZ
  },
  {
    path: '/questionnaire',
    name: '单题问卷',
    component: questionnaire
  },
  {
    path: '/startExamSimple',
    name: '问卷1',
    component: resolve => require(['@/project/exam/startExamSimple'],resolve)
  },
  {
    path: '/startExam',
    name: '问卷',
    component: startExam
  },
  {
    path: '/invoiceConfirm',
    name: '发票确认',
    component: resolve => require(['@/project/activitiesProject/invoiceConfirm'],resolve)
  },
  {
    path: '/startCheck',
    name: '在线测评',
    component: startCheck
  },
  {
    path: '/startExamNoPerson',
    name: '外院测评',
    component: startExamNoPerson
  },
  {
    path: '/prescnoVerify',
    name: '前置审方跳转',
    component: prescnoVerify
  },
  {
    path: '/patientlabinfo',
    name: '查询LIS信息',
    component: patientlabinfo
  },
  {
    path: '/orderFood',
    name: '订餐服务',
    component: orderFood
  },
  {
    path: '/yxcrmregister',
    name: '优选crm注册',
    component: yxcrmregister
  },
  {
    path: '/mdt',
    name: 'MDT信息',
    component: mdt
  },
  {
    path: '/mdtregister',
    name: 'MDT登记',
    component: mdtregister
  },
  {
    path: '/vipFet',
    name: 'fet信息',
    component: vipFet
  },
  {
    path: '/vipHcg',
    name: 'hcg信息',
    component: vipHcg
  },
  {
    path: '*',
    component: noFind
  }

]
export default new Router({
  mode: 'history',
  routes: router,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js